<template>
    <div class="main-indent">
        <div class="open-mobile-menu-background"
             v-if="isOpenMobileMenu"
        />

        <Header @toggleMobileMenu="isOpenMobileMenu = $event"/>

        <main>
            <router-view />
        </main>


        <CookiesSettings v-if="isShowCookiesPopup"
                         @hide="isShowCookiesPopup = false"
        />

        <ScrollToTop/>

        <Footer/>
    </div>
</template>

<script>
import seo from '@/seo/seo.json'

export default {
    name: "defaultLayout",

    metaInfo() {
        const currentRouteMeta = seo[this.$route.name] || seo['HomePage']

        return {
            title: currentRouteMeta.title,
            meta: [
                {
                    name: 'google-site-verification',
                    content: 'Yu5JAGs-Kv2s7GMaA7oOHvnppDhEkRAcySZ63eseNyI',
                },
                {
                    name: 'description',
                    content: currentRouteMeta.description,
                },
                {
                    property: 'og:title',
                    content: currentRouteMeta.title,
                },
                {
                    property: 'og:description',
                    content: currentRouteMeta.description,
                },
                {
                    property: 'twitter:title',
                    content: currentRouteMeta.title,
                },
                {
                    property: 'twitter:description',
                    content: currentRouteMeta.description,
                },
                {
                    property: "url",
                    content: `${window.location.origin}${this.$route.fullPath}`,
                },
                {
                    property: "og:url",
                    content: `${window.location.origin}${this.$route.fullPath}`,
                },
                {
                    property: "twitter:url",
                    content: `${window.location.origin}${this.$route.fullPath}`,
                },
                {
                    property: "og:image",
                    content: 'img/logo.png',
                },
                {
                    property: "og:image:type",
                    content: 'image/png',
                },
                {
                    property: "og:image:width",
                    content: '157',
                },
                {
                    property: "og:image:height",
                    content: '52'
                },
            ],
            link: [
                { rel: "canonical", href: `${window.location.origin}` }
            ]
        }
    },

    components: {
        Header: () => import('@/components/Header.vue'),
        Footer: () => import('@/components/Footer.vue'),
        ScrollToTop: () => import('@/components/ScrollToTop.vue'),
        CookiesSettings: () => import('@/components/CookiesSettings.vue')
    },

    data() {
        return {
            isShowCookiesPopup: true,

            isOpenMobileMenu: false
        }
    },

    mounted() {
        this.isShowCookiesPopup = !document.cookie.split("; ").some(cookie => cookie.startsWith("cookie="))
    }
}
</script>

<style scoped>
.open-mobile-menu-background {
    display: none;
}

@media (max-width: 870px) {
    .open-mobile-menu-background {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: #26202066;
        z-index: 10;
    }
}
</style>
